import { postFormData } from '@helpers/http.helpers';

export async function uploadFile(
  url: string,
  body: FormData,
  withAuthHeader: boolean
): Promise<string> {
  return postFormData<string>(url, body, withAuthHeader);
}
